import { useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import Reveal from "./Reveal";

const TESTIMONIALS = [
  {
    name: "Linda S.",
    role: "Facial client",
    text: "Beauty & Balance by Bella's facials have been a game-changer for my skin. I feel more confident and radiant than ever before.",
  },
  {
    name: "David C.",
    role: "Returning client",
    text: "I've experienced various beauty treatments, but Bella's rejuvenating facials have truly made a visible difference in reducing my fine lines.",
  },
  {
    name: "Emily J.",
    role: "Massage client",
    text: "Therapeutic massages at Beauty & Balance have transformed my well-being, making me feel rejuvenated and balanced.",
  },
];

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const total = TESTIMONIALS.length;

  const prev = () => setIdx((i) => (i - 1 + total) % total);
  const next = () => setIdx((i) => (i + 1) % total);

  const t = TESTIMONIALS[idx];

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 md:py-36 bg-[#0F1F4E] text-[#F8F1D8] overflow-hidden grain"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="grid grid-cols-12 gap-8 items-start">
          <div className="col-span-12 md:col-span-4">
            <Reveal>
              <span className="overline" style={{ color: "#EAD584" }}>
                Talk of the town
              </span>
            </Reveal>
            <Reveal delay={1}>
              <h2 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] font-light">
                Words from <span className="italic" style={{ color: "#EAD584" }}>the chair.</span>
              </h2>
            </Reveal>
          </div>

          <Reveal delay={2} className="col-span-12 md:col-span-8">
            <Quote className="w-10 h-10 mb-6 opacity-60" />
            <blockquote
              key={idx}
              data-testid="testimonial-quote"
              className="font-serif text-2xl sm:text-3xl md:text-4xl leading-snug font-light"
              style={{ animation: "fadeUp 0.6s ease both" }}
            >
              &ldquo;{t.text}&rdquo;
            </blockquote>
            <div className="mt-10 flex items-end justify-between flex-wrap gap-6">
              <div>
                <div className="font-serif text-xl">— {t.name}</div>
                <div className="overline" style={{ color: "#EAD584" }}>{t.role}</div>
              </div>
              <div className="flex items-center gap-3">
                <button
                  onClick={prev}
                  data-testid="testimonial-prev"
                  aria-label="Previous testimonial"
                  className="w-12 h-12 rounded-full border border-[#F8F1D8]/40 inline-flex items-center justify-center hover:bg-[#F8F1D8]/10 transition-colors"
                >
                  <ChevronLeft className="w-5 h-5" />
                </button>
                <span className="overline" data-testid="testimonial-counter">
                  {String(idx + 1).padStart(2, "0")} / {String(total).padStart(2, "0")}
                </span>
                <button
                  onClick={next}
                  data-testid="testimonial-next"
                  aria-label="Next testimonial"
                  className="w-12 h-12 rounded-full border border-[#F8F1D8]/40 inline-flex items-center justify-center hover:bg-[#F8F1D8]/10 transition-colors"
                >
                  <ChevronRight className="w-5 h-5" />
                </button>
              </div>
            </div>
          </Reveal>
        </div>
      </div>

      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}
